import * as ActionType from "./cashoutRequest.type";

const initialState = {
  cashoutRequest: [],
  stats: {},
};

export const cashoutRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_CASHOUT_REQUEST:
      return {
        ...state,
        cashoutRequest: action.payload,
      };

    case ActionType.UPDATE_CASHOUT_REQUEST:
      return {
        ...state,
        cashoutRequest: state.cashoutRequest.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };

    case ActionType.GET_CASHOUT_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    default:
      return state;
  }
};
